"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.25.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSearchResultResponseOrderItemsInnerStatusEnum = exports.OrderSearchResultResponseOrderItemsInnerOrderItemTypeEnum = void 0;
exports.OrderSearchResultResponseOrderItemsInnerOrderItemTypeEnum = {
    Product: 'PRODUCT'
};
exports.OrderSearchResultResponseOrderItemsInnerStatusEnum = {
    Canceled: 'CANCELED',
    Accepted: 'ACCEPTED',
    Reserved: 'RESERVED',
    Expired: 'EXPIRED',
    Archived: 'ARCHIVED',
    Open: 'OPEN',
    Failure: 'FAILURE',
    Pending: 'PENDING',
    Declined: 'DECLINED'
};
